import { FunctionComponent, useEffect } from "react"
import PageLoaderWithIcon from "src/components/common/PageLoaderWithIcon/PageLoaderWithIcon"
import "./VehicleIncidentsSwitchViewLoader.css"

const VehicleIncidentsSwitchViewLoader: FunctionComponent = () => {

    useEffect(() => {
        const target = document.getElementById("vehicle-incidents-table")

        if (target) {
            target.style.opacity = "0.8"
        }

        return () => {
            if (target) {
                target.style.opacity = "1"
            }
        }
        
    }, [])


    return (
        <div className="VehicleIncidentsSwitchViewLoader">
            <PageLoaderWithIcon
                icon="visibility"
                loaderText="Switching Views"
            />
        </div>
    )
}

export default VehicleIncidentsSwitchViewLoader
